import React, { useMemo } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { Rate } from 'antd';
import { LandingContentInfoModel } from '@/types/home';
import { useWindowSize } from 'react-use';

const CustomersTalkUsContent = ({
  contentInfo
}:{
  contentInfo?: LandingContentInfoModel
}) => {
  const { width } = useWindowSize()

  const getPaddingLeft = useMemo(() => {
    if (width <= 1200) return 0
    return (width - 1200) / 2
  }, [width])

  const getContent = useMemo(() => {
    return contentInfo?.title?.length>0 ? <div className={styles.content}>
      {contentInfo?.title && <h2>{contentInfo?.title}</h2>}

      {contentInfo?.desc && <p className={styles.titleDesc}>
        {contentInfo?.desc}
      </p>}

      <div 
        className={styles.container}
        style={{
          paddingLeft: getPaddingLeft, 
          paddingRight: getPaddingLeft, 
          marginLeft:`-${getPaddingLeft}px`, 
          marginRight:`-${getPaddingLeft}px`,
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        {contentInfo?.cards?.map((item, index) => {
          return (
            <div className={styles.cardContainer} key={index + item?.name}>
              <div className={styles.userContainer}>
                <Image
                  src={item?.imgPath ?? ''}
                  alt={item?.name}
                  className={styles.icon}
                  width={46}
                  height={46}
                />
                <span className={styles.userName}>{item?.name}</span>
              </div>
              
              <div className={styles.line}/>

              <ul className={styles.starContainer}>
                <Rate className={styles.star} allowHalf disabled defaultValue={Number(item?.points)} value={Number(item?.points)} />
                <span className={styles.date}>{item?.date}</span>
              </ul>
              <div className={styles.desc}>{item?.desc}</div>
            </div>
          );
        })}
      </div>
    </div> : null
  }, [contentInfo, getPaddingLeft])

  return (<>{getContent}</>);
};

export default CustomersTalkUsContent;
